import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import axiosInstance from '../config/axios';

const saveSubscription = async (subscription: PushSubscription) => {
  const payload: PushSubscriptionJSON = subscription.toJSON();
  return axiosInstance.post('/push/subscriptions', payload);
};

const deleteSubscription = async (endpoint: string) =>
  axiosInstance.delete('/push/subscriptions', {
    data: { endpoint },
  });

export const pushApi = {
  saveSubscription,
  deleteSubscription,
};

export const useSavePushSubscription = () =>
  useMutation({
    mutationFn: saveSubscription,
    onError: (error) => {
      console.error('Failed to save push subscription:', error);
      toast.error('Не удалось подключить уведомления');
    },
  });

export const useDeletePushSubscription = () =>
  useMutation({
    mutationFn: deleteSubscription,
    onError: (error) => {
      console.error('Failed to delete push subscription:', error);
      toast.error('Не удалось отключить уведомления');
    },
  });
